<template>
  <CNavbar expandable="md" type="dark" color="dark" style="font-size: 120%;">
    <CContainer>
      <CToggler in-navbar @click="collapsed = !collapsed"/>
      <CNavbarBrand to="/" class="d-flex align-items-center">
        <c-icon class="mr-2" name="cilCart" size="lg"></c-icon>
        Warzywa
      </CNavbarBrand>
      <CCollapse :show="collapsed" navbar>
        <CNavbarNav>
          <c-nav-item to="/">Strona główna</c-nav-item>
          <c-nav-item to="/products">Produkty</c-nav-item>
        </CNavbarNav>

        <!-- Right aligned nav items -->
        <CNavbarNav class="ml-auto">
          <c-nav-item to="/cart">
            <c-button style="font-size: 100%;" to="/cart" variant="outline"
                      color="secondary">

              Koszyk ({{ $store.getters.totalPrice.toFixed(2) }} zł)
            </c-button>
          </c-nav-item>
        </CNavbarNav>
      </CCollapse>
    </CContainer>
  </CNavbar>
</template>
<script>
export default {
  name: 'TheNavbar',
  data() {
    return {
      collapsed: false
    }
  }
}
</script>